import {
  calendarYearOf,
  getReportingSchoolYears,
  monthNames,
  schoolYearLabel,
  schoolYearMonths,
} from '../utils/reportingPeriod';

const schoolYears = getReportingSchoolYears();

const rangeModes = [
  { mode: 'period', label: 'This Period' },
  { mode: 'ytd', label: 'Year to Date' },
];

const formatDateTime = (date) =>
  date.toLocaleString('en-PH', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });

// Month / school year / range picker shared by the public and admin dashboards.
// `period` is the object returned by useReportingPeriod().
function ReportingPeriodBar({ period, loading, updatedAt }) {
  const { month, setMonth, schoolYear, setSchoolYear, rangeMode, setRangeMode } = period;
  const allYears = schoolYear === 'all';

  return (
    <section className="w-full bg-white rounded-xl border border-gray-200 shadow-sm p-4">
      <div className="flex flex-wrap items-center gap-3">
        <p className="mr-1 text-base font-semibold text-gray-600">Reporting Period</p>
        <select
          value={month}
          onChange={(e) => setMonth(Number(e.target.value))}
          disabled={allYears}
          aria-label="Month"
          className="flex-1 min-w-[10rem] rounded-lg border border-gray-200 bg-white text-base font-medium text-gray-900 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-gold disabled:bg-gray-100 disabled:text-gray-500"
        >
          {schoolYearMonths.map((monthIndex) => (
            <option key={monthIndex} value={monthIndex}>
              {monthNames[monthIndex]}
              {allYears ? '' : ` ${calendarYearOf(schoolYear, monthIndex)}`}
            </option>
          ))}
        </select>
        <select
          value={schoolYear}
          onChange={(e) => setSchoolYear(e.target.value === 'all' ? 'all' : Number(e.target.value))}
          aria-label="School year"
          className="flex-1 min-w-[10rem] rounded-lg border border-gray-200 bg-white text-base font-medium text-gray-900 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-gold"
        >
          <option value="all">All School Years</option>
          {[...schoolYears].reverse().map((year) => (
            <option key={year} value={year}>
              {schoolYearLabel(year)}
            </option>
          ))}
        </select>
        <div role="group" aria-label="Range" className="flex w-full sm:w-auto sm:flex-1 sm:min-w-[16rem] overflow-hidden rounded-lg border border-gray-200">
          {rangeModes.map(({ mode, label }) => (
            <button
              key={mode}
              type="button"
              aria-pressed={rangeMode === mode}
              disabled={allYears}
              onClick={() => setRangeMode(mode)}
              className={`flex-1 px-4 py-2 text-base font-medium transition disabled:opacity-50 ${
                rangeMode === mode ? 'bg-navy-light text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <p className="mt-3 text-sm text-gray-600">
        Data as of {loading || !updatedAt ? '--' : formatDateTime(updatedAt)}
      </p>
    </section>
  );
}

export default ReportingPeriodBar;
